export const downloadFileFromBase64 = async (base64String, filename) => {
  const mimeType = base64String.split(';')[0].split(':')[1];
  let extension = '';

  try {
    switch (mimeType) {
      case 'image/png':
        extension = 'png';
        break;
      case 'image/jpeg':
        extension = 'jpg';
        break;
      case 'application/octet-stream':
      case 'application/pdf':
        extension = 'pdf';
        break;
      default:
        extension = 'raw';
        break
    }
  } catch (error) {
    console.error('Error detecting file type:', error);
    extension = 'raw';
  }

  const fileNameWithExtension = `${filename || "arquivo"}.${extension}`;

  const link = document.createElement('a');

  link.href = base64String;

  link.download = fileNameWithExtension;

  link.click();
};